module.exports = __webpack_public_path__ + "static/media/LOMTAUSI_MENU-normal.a42fe18a.png";